import PropTypes from "prop-types";

export const Hidden = ({ input, fieldAttr }) => (
    <input id={input.name} {...input} {...fieldAttr} type="hidden" />
);

Hidden.defaultProps = {
    input: {},
    id: null,
    fieldAttr: {},
};

Hidden.propTypes = {
    input: PropTypes.oneOfType([PropTypes.object]),
    id: PropTypes.string,
    fieldAttr: PropTypes.oneOfType([PropTypes.object]),
};
